export default __webpack_public_path__ + "scripts/resource/936d4f743a18c67c094d0b44934a3398.svg";